import React, { useState, useEffect } from "react";
import {
  Spinner,
  Button,
  Form,
  Col,
  Row,
  FloatingLabel,
  Modal
} from "react-bootstrap";

import { useQuery } from "@tanstack/react-query";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

function UsersEditForm({ handleSubmit, userData }) {
  const [formData, setFormData] = useState(userData && userData);
  const [validated, setValidated] = useState(false);

  // const handleChange = (event) => {
  //   setFormData({ ...formData, [event.target.name]: event.target.value });
  // };

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    // Handle switches
    if (type === "checkbox") {
      setFormData({
        ...formData,
        [name]: checked
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleFormSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      handleSubmit(event, formData);
    }
    setValidated(true);
  };

  return (
    <>
      <Form
        onSubmit={handleFormSubmit}
        noValidate
        validated={validated}
        // onSubmit={(event) => handleSubmit(event, formData, validateForm)}
      >
        <Row className="gx-3 gy-3">
          <Col md="12">
            <FloatingLabel
              controlId="floatingInput"
              label="First Name"
              className=""
            >
              <Form.Control
                type="text"
                value={formData?.first_name}
                name="first_name"
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid first name.
              </Form.Control.Feedback>
            </FloatingLabel>
          </Col>
          <Col md="12">
            <FloatingLabel
              controlId="floatingInput"
              label="Last Name"
              className=""
            >
              <Form.Control
                type="text"
                value={formData?.last_name}
                name="last_name"
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid last name.
              </Form.Control.Feedback>
            </FloatingLabel>
          </Col>
          <Col md="12">
            {/* <Form.Check
              type="switch"
              id="custom-switch-active"
              label="Active"
              name="is_active"
              onChange={handleChange}
              checked={formData?.is_active}
            /> */}
            <Form.Check
              type="switch"
              id="custom-switch-staff"
              label={formData?.is_staff ? "Staff" : "Not Staff"}
              name="is_staff"
              onChange={handleChange}
              checked={formData?.is_staff ? true : false}
            />
          </Col>
          {/* <Col md="12">
            <FloatingLabel controlId="floatingInput" label="Email" className="">
              <Form.Control
                type="text"
                value={formData?.email}
                name="email"
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid email.
              </Form.Control.Feedback>
            </FloatingLabel>
          </Col> */}
          {/* <Col md="12">
            <FloatingLabel
              controlId="floatingInput"
              label="User Name"
              className=""
            >
              <Form.Control
                type="text"
                value={formData?.username}
                name="username"
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid User name.
              </Form.Control.Feedback>
            </FloatingLabel>
          </Col> */}

          {/* <Col md="12">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Date Joined"
                value={formData?.date_joined}
                onChange={(newValue) =>
                  handleChange({
                    target: { name: "date_joined", value: newValue }
                  })
                }
              />
            </LocalizationProvider>
          </Col> */}

          <Col md="12" className="d-grid gap-2">
            <Button variant="primary" type="submit" size="md">
              Save
            </Button>
          </Col>
        </Row>
      </Form>

      {/* {loading && (
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      )} */}
    </>
  );
}

export default UsersEditForm;
